import RecepientSelect from './RecepientSelect';

export default RecepientSelect;
